// Bain & Company specific configuration
export const BainConfig = {
  // Bain branding
  BRANDING: {
    name: "Bain & Company Edition",
    color: 0xc41e3a, // Bain red
    logo: "🏢"
  },

  // Bain-specific methods that need to be implemented
  METHODS: {
    // RAPID Framework
    applyRAPIDFramework: {
      description: "Apply RAPID decision-making framework",
      implementation: "alignShapesInRAPIDFormat"
    },

    // NPS Analysis
    applyNPSAnalysis: {
      description: "Apply Net Promoter Score analysis layout",
      implementation: "createNPSLayout"
    },

    // CEO Dashboard
    applyCEODashboard: {
      description: "Apply CEO dashboard template",
      implementation: "createCEODashboard"
    },

    // Five Forces
    applyFiveForces: {
      description: "Apply Porter's Five Forces analysis",
      implementation: "createFiveForcesLayout"
    },

    // Value Chain
    applyValueChain: {
      description: "Apply value chain analysis",
      implementation: "createValueChainLayout"
    },

    // SWOT Analysis
    applySWOTAnalysis: {
      description: "Apply SWOT analysis framework",
      implementation: "createSWOTLayout"
    }
  },

  // Bain-specific level templates
  LEVEL_TEMPLATES: {
    RAPID_FRAMEWORK: {
      instructions: "Apply RAPID framework: Arrange decision roles (Recommend, Agree, Perform, Input, Decide)",
      shapes: [
        { type: "rectangle", x: 300, y: 200, w: 80, h: 50, color: 0xc41e3a, label: "R" },
        { type: "rectangle", x: 400, y: 200, w: 80, h: 50, color: 0xc41e3a, label: "A" },
        { type: "rectangle", x: 500, y: 200, w: 80, h: 50, color: 0xc41e3a, label: "P" },
        { type: "rectangle", x: 600, y: 200, w: 80, h: 50, color: 0xc41e3a, label: "I" },
        { type: "rectangle", x: 700, y: 200, w: 80, h: 50, color: 0xc41e3a, label: "D" }
      ]
    },

    NPS_ANALYSIS: {
      instructions: "Create NPS analysis: Arrange Promoters, Passives, and Detractors",
      shapes: [
        { type: "rectangle", x: 350, y: 250, w: 120, h: 80, color: 0x27ae60, label: "Promoters\n9-10" },
        { type: "rectangle", x: 500, y: 250, w: 120, h: 80, color: 0xf39c12, label: "Passives\n7-8" },
        { type: "rectangle", x: 650, y: 250, w: 120, h: 80, color: 0xe74c3c, label: "Detractors\n0-6" }
      ]
    },

    CEO_DASHBOARD: {
      instructions: "CEO Dashboard: Align key performance indicators",
      shapes: [
        { type: "rectangle", x: 300, y: 150, w: 150, h: 60, color: 0x3498db, label: "Revenue" },
        { type: "rectangle", x: 500, y: 150, w: 150, h: 60, color: 0x2ecc71, label: "Profit" },
        { type: "rectangle", x: 700, y: 150, w: 150, h: 60, color: 0xe74c3c, label: "Growth" },
        { type: "rectangle", x: 300, y: 250, w: 150, h: 60, color: 0x9b59b6, label: "Market Share" },
        { type: "rectangle", x: 500, y: 250, w: 150, h: 60, color: 0xf39c12, label: "Customer Sat" },
        { type: "rectangle", x: 700, y: 250, w: 150, h: 60, color: 0x1abc9c, label: "Innovation" }
      ]
    }
  },

  // Bain-specific analytics metrics
  ANALYTICS_METRICS: {
    frameworksApplied: 0,
    consultingEfficiency: 0,
    clientReadiness: 0,
    strategicThinking: 0
  }
};

export default BainConfig;




